<template>
  <div class="frame8">
    <div class="frame8_box">
      <img
        src="../../../../public/img/shares_Info/close_tm.png"
        alt=""
        class="frame8_box_img"
        @click="frame8_close"
      />
      <div class="frame8_box_content">
        <img
          src="../../../../public/img/shares_Info/img1.png"
          alt=""
          class="frame8_box_content_img1"
        />
        <div style="text-align: center; margin-top: 75px">
          <img
            src="../../../../public/img/shares_Info/qianshuzhitou.png"
            alt=""
            class="frame8_box_content_img2"
          />
        </div>
        <div class="frame8_bottom">
          <div class="frame8_bottom_button1">登陆/注册</div>
          <div class="frame8_bottom_button2">下载APP</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods:{
    frame8_close(){
      this.$emit('frame8_close')
    }
  }
};
</script>

<style scoped>
.frame8 {
  width: 187px;
  height: 248px;
  background-color: transparent;
  position: fixed;
  top: 50%;
  /* left: calc(50% - 193px); */
  right: 24px;
  z-index: 9999999;
}
.frame8_box {
  width: 100%;
  height: 100%;
  position: relative;
}
.frame8_box_img {
  position: absolute;
  width: 25px;
  height: 25px;
  top: 0;
  right: 0;
  cursor: pointer;
}
.frame8_box_content {
  width: 152px;
  height: 213px;
  background-color: #ffffff;
  box-shadow: 0px 2px 51px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  position: absolute;
  bottom: 0;
  left: 0;
}
.frame8_box_content_img1 {
  width: 100px;
  height: 100px;
  position: absolute;
  top: -31px;
  left: 45px;
}
.frame8_box_content_img2 {
  width: 86px;
  height: 21px;
}
.frame8_bottom_button1 {
  width: 124px;
  height: 29px;
  background-image: linear-gradient(135deg, #f8c54a 0%, #fcad2a 100%),
    linear-gradient(#539cff, #539cff);
  background-blend-mode: normal, normal;
  box-shadow: 0px 4px 9px 1px rgba(252, 173, 42, 0.32);
  border-radius: 13px;
  font-size: 15px;
  line-height: 29px;
  color: #ffffff;
  text-align: center;
  margin: 0 auto;
  margin-top: 20px;
  cursor: pointer;
}
.frame8_bottom_button2 {
  width: 124px;
  height: 28px;
  background-image: linear-gradient(135deg, #3e8df9 0%, #2b5de3 100%),
    linear-gradient(#539cff, #539cff);
  background-blend-mode: normal, normal;
  box-shadow: 0px 4px 15px 1px rgba(43, 93, 227, 0.11);
  border-radius: 13px;
  font-size: 15px;
  line-height: 28px;
  color: #ffffff;
  text-align: center;
  margin: 0 auto;
  margin-top: 12px;
  cursor: pointer;
}
</style>